import React from "react";
import PropTypes from "prop-types";
import Button from "@p1s/p1s-common-react/Button";

const CompleteResetPassword = ({ email, onComplete }) => {
    return (
        <div className="completeAccountSetup">
            <div className="form-title"><span className="ion-android-done"/><span className="title">Reset Password</span></div>

            <div className="linked-email">{email}</div>

            <div name="main-text" className="form-subtitle">You have successfully reset your password! Click OK to log in.</div>

            <div className="button-container">
                <Button id="btnCompleteAccountSetup" className="btn btn-primary-action pull-right btn btn-default" onClick={onComplete}>Ok</Button>
            </div>
        </div>
    );
};

CompleteResetPassword.propTypes = {
    onComplete: PropTypes.func,
    email: PropTypes.string
};

export default CompleteResetPassword;
